import { Action } from "redux";
import {
  RetentionFactorData,
  NutrientMap,
  CategoryMap,
  ReferenceMeasureMap,
  DataSourceMap,
} from "../reducers/referenceData";

export const SET_RETENTION_FACTOR_DATA = "SET_RETENTION_FACTOR_DATA";
export const SET_NUTRIENT_DATA = "SET_NUTRIENT_DATA";
export const SET_CATEGORIES = "SET_CATEGORIES";
export const SET_REFERENCE_MEASURES = "SET_REFERENCE_MEASURES";
export const SET_DATA_SOURCES = "SET_DATA_SOURCES";

export interface IActionsSetRetentionFactorData extends Action {
  type: "SET_RETENTION_FACTOR_DATA";
  retentionFactorData: RetentionFactorData;
}

export interface IActionsSetNutrientData extends Action {
  type: "SET_NUTRIENT_DATA";
  nutrientData: NutrientMap;
}

export interface IActionsSetCategories extends Action {
  type: "SET_CATEGORIES";
  categories: CategoryMap;
}
export interface IActionsSetReferenceMeasures extends Action {
  type: "SET_REFERENCE_MEASURES";
  referenceMeasures: ReferenceMeasureMap;
}

export interface IActionsSetDataSources extends Action {
  type: "SET_DATA_SOURCES";
  dataSources: DataSourceMap;
}

export type ReferenceDataActions =
  | IActionsSetRetentionFactorData
  | IActionsSetNutrientData
  | IActionsSetCategories
  | IActionsSetReferenceMeasures
  | IActionsSetDataSources;
